import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { message } from 'antd'
import { updateSiteConfigs } from 'actions/Site'
import { fetchSocialMedia, deleteSocialMedia } from 'actions/SocialMedia'
import SocialMediaView from 'components/pages/socialMedia'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchSocialMedia: bindActionCreators(fetchSocialMedia, dispatch),
  deleteSocialMedia: bindActionCreators(deleteSocialMedia, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isLoading', 'setIsLoading', false),
  withState('stateSearch', 'setStateSearch', {}),
  withState('data', 'setData', {}),
  withHandlers({
    getList: props => async (params) => {
      const { setData, setIsLoading } = props
      setIsLoading(true)
      try {
        const res = await props.fetchSocialMedia(params)
        setData({
          list: res.data,
          meta: res.meta,
        })
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
  }),
  withHandlers({
    handleDelete: props => async (id) => {
      const { setIsLoading, getList } = props
      setIsLoading(true)

      try {
        const res = await props.deleteSocialMedia(id)
        message.success(res)
        getList()
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfigs({
        titlePage: 'Social Media',
        activePage: 'social-media',
        activeSubPage: 'social-media',
      })

      this.props.getList()
    },
  }),
)(SocialMediaView)
